import { AppConfig } from '../../../common/model/config';
import { ORDER_TYPE_DELIVERY } from '../../../common/model/order-types';
import { liveloTheme } from '../themes/livelo.theme';

export const liveloConfig: AppConfig = {
  appName: 'livelo',
  appTitle: 'Pede Pronto e Livelo',
  appDescription: 'Peça aqui com o Pede Pronto e Livelo.',
  aggregator: 820,
  takeOutAggregatorId: 21,
  brand: 2016,
  theme: liveloTheme,
  faviconPath: '/favicons/favicon-livelo.ico',
  defaultOrderType: ORDER_TYPE_DELIVERY,
  defaultLocation: {
    // Avenida Paulista
    latitude: -23.5631043,
    longitude: -46.6565712,
  },
  featureFlags: {
    embeddedApplication: false,
    getBrandThemeFromBackend: false,
    shuffleCompanyArray: false,
    gmapsAddress: true,
    showOptionsTabsAggregators: true,
    filterByDeliveryArea: true,
    useLocalAggregatorHeaderImg: true,
    localAggregatorImgPath: '/aggregator-headers/aggregator-header-livelo.png',
  },
};
